import React, { useState, FC, FocusEvent, ChangeEvent, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { TBaseTextField } from '../../types/BaseTextField.type'
import { IReduxState } from '../../../ReduxImpl/reducers/index'
import { updateCustomError } from '../../../ReduxImpl/actions/index'

const BaseTextField: FC<TBaseTextField> = (props) => {
  const {
    field,
    type,
    tracker,
    value: _value,
    errors,
    fieldValidationErrorsComponent,
    isValid,
    onChange,
  } = props

  const dispatch = useDispatch()

  const removeError = useSelector((state: IReduxState) => state.removeError)
  const customError = useSelector((state: IReduxState) => state.customError)

  const [hasFocus, setHasFocus] = useState(false)
  const [value, setValue] = useState(_value)

  const FieldValidationErrors = fieldValidationErrorsComponent

  const hasValueOrFocus = hasFocus || value !== ''
  const hasAnyError = !!errors?.length
  const label = field.model.title
  const id = field.valueField.id
  const name = field.valueField.name
  const emailRegex = /^\w+([\+.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/
  const hasCustomError = !!customError

  const onFocus = (e: FocusEvent<HTMLInputElement>) => {
    tracker.onFocusField(field, e.target.value)
    setHasFocus(true)
    if (removeError) {
      dispatch(updateCustomError(''))
    }
  }

  const onBlur = (e: FocusEvent<HTMLInputElement>) => {
    tracker.onBlurField(field, e.target.value)
    setHasFocus(false)
  }

  useEffect(() => {
    if (typeof window !== 'undefined' && 'customElements' in window) {
      import('@patternfly/pfe-icon-onhighway/dist/pfe-icon.js');
    }
  }, []);

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    setValue(e.target.value)
    onChange(field.valueField.name, e.target.value, isValid, [])
    if (e.target.type == 'email') {
      if (e.target.value.match(emailRegex) && e.target.value) {
        onChange(field.valueField.name, e.target.value, isValid, [])
      } else {
        setHasFocus(true)

        onChange(field.valueField.name, e.target.value, isValid, [
          'Invalid email address',
        ])
      }
    }
  }

  return (
    <div
      className={`sitecore-jss-form__control sitecore-jss-form__control--text-box ${
        hasAnyError ? 'sitecore-jss-form__control--has-error' : ''
      } ${
        field.model.name === 'EmailText'
          ? 'sitecore-jss-form__control--emailTextbox'
          : ''
      } ${
        field.model.name === 'CompanyName'
          ? 'sitecore-jss-form__control--companyName'
          : ''
      }
 `}
    >
      <label
        htmlFor={id}
        className={`sitecore-jss-form__label ${
          hasValueOrFocus ? 'sitecore-jss-form__label--has-focus' : ''
        }  `}
      >
        {label}
      </label>

      <input
        id={id}
        name={name}
        className={`sitecore-jss-form__field`}
        type={type}
        onFocus={onFocus}
        onBlur={onBlur}
        onChange={handleChange}
        value={_value}
      />

      {field.model.name === 'EmailText' && removeError && hasCustomError ? (
        <div className="sitecore-jss-form__error-list error">
          <pfe-icon
            icon="cnh-alert-triangle-line"
            size="14"
            className="sitecore-jss-form__error-list__icon PFElement"
          ></pfe-icon>
          <span>&nbsp; {customError}</span>
        </div>
      ) : (
        ''
      )}

      {FieldValidationErrors && <FieldValidationErrors {...props} />}
    </div>
  )
}

export default BaseTextField
